import { AuthScopes, ClaimCenterWithBookables } from '@Generated/back-office-client/src'
import { CheckIcon, DotsVerticalIcon } from '@radix-ui/react-icons'
import { DropdownMenu, Flex, Text } from '@radix-ui/themes'
import { useMemo } from 'react'
import './style.scss'
import { WithPermissions } from '@Components/common/with-permissions'

export const ActionMenu = ({
  claimCenters,
  activeClaimCenter,
  hasUnscheduledBookables,
  canRemoveSlot,
  onAddAppointmentSlot,
  onRemoveAppointmentSlot,
  onScheduleUnavailability,
  onLocationSelection,
}: {
  claimCenters: ClaimCenterWithBookables[]
  activeClaimCenter: ClaimCenterWithBookables
  hasUnscheduledBookables: boolean
  canRemoveSlot: boolean
  onAddAppointmentSlot: () => void
  onRemoveAppointmentSlot: () => void
  onScheduleUnavailability: () => void
  onLocationSelection: (claimCenter: ClaimCenterWithBookables) => void
}) => {
  const claimCenterOptions = useMemo(() => {
    return claimCenters
      ?.sort((a, b) => a.name.localeCompare(b.name))
      .map((c) => (
        <DropdownMenu.Item key={c.id} onClick={() => onLocationSelection(c)}>
          <Flex align="center" style={{ justifyContent: 'space-between', width: '100%' }}>
            <Text>{c.name}</Text>
            {c.id === activeClaimCenter.id ? (
              <Flex justify="end" style={{ paddingLeft: '6px' }}>
                <CheckIcon className="action-menu-active-location" />
              </Flex>
            ) : null}
          </Flex>
        </DropdownMenu.Item>
      ))
  }, [activeClaimCenter.id, claimCenters, onLocationSelection])

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Flex align="center">
          <DotsVerticalIcon style={{ cursor: 'pointer' }} height="20" width="20" />
        </Flex>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        {hasUnscheduledBookables ? (
          <WithPermissions requiredPermissions={AuthScopes.writeclaim_center_schedules}>
            <DropdownMenu.Item onClick={onAddAppointmentSlot}>
              Add Appointment Slot
            </DropdownMenu.Item>
            <DropdownMenu.Separator />
          </WithPermissions>
        ) : null}

        {canRemoveSlot ? (
          <WithPermissions requiredPermissions={AuthScopes.writeclaim_center_schedules}>
            <DropdownMenu.Item onClick={onRemoveAppointmentSlot}>
              Remove Appointment Slot
            </DropdownMenu.Item>
            <DropdownMenu.Separator />
          </WithPermissions>
        ) : null}

        <DropdownMenu.Sub>
          <DropdownMenu.SubTrigger>Select Location</DropdownMenu.SubTrigger>
          <DropdownMenu.SubContent>{claimCenterOptions}</DropdownMenu.SubContent>
        </DropdownMenu.Sub>

        <WithPermissions requiredPermissions={AuthScopes.writeclaim_center_exceptions}>
          <DropdownMenu.Separator />
          <DropdownMenu.Item onClick={onScheduleUnavailability}>
            Schedule Unavailability
          </DropdownMenu.Item>
        </WithPermissions>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  )
}
